/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = [''];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2dpdGh1Yi93b3Jrc3BhY2Uvc3JjL2FwcC9sb2dpbi9yZWN1cGVyYXItc2VuaGEvcmVjdXBlcmFyLXNlbmhhLmNvbXBvbmVudC5jc3Muc2hpbS5uZ3N0eWxlLnRzIiwidmVyc2lvbiI6Mywic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsibmc6Ly8vZ2l0aHViL3dvcmtzcGFjZS9zcmMvYXBwL2xvZ2luL3JlY3VwZXJhci1zZW5oYS9yZWN1cGVyYXItc2VuaGEuY29tcG9uZW50LmNzcyJdLCJzb3VyY2VzQ29udGVudCI6WyIgIl0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/login/recuperar-senha/recuperar-senha.component.css.shim.ngstyle.ts